import type { ConsentResponse } from "@/core/types";
import { createConsentPayloadTyped } from "@/utils/consentUtilsTyped";
import { createVersionedAcknowledgementPayload } from "@/utils/acknowledgementUtilsTyped";
import type { PolicyMetaData, ConsentedPolicy } from "@/core/types";
import type { UUID } from "@/core/types";

type ConsentPayloadParams = {
  consentGivenBy?: UUID;
  consentResponse: ConsentResponse;
  consentType: ConsentedPolicy;
  patientId: UUID;
  policyMetadata: PolicyMetaData;
  policyVersion: string;
};

export function getConsentPayload(params: ConsentPayloadParams) {
  const { consentGivenBy, consentResponse, consentType, patientId, policyMetadata, policyVersion } =
    params;

  const versionedAcknowledgementPayload = createVersionedAcknowledgementPayload({
    consentGivenBy,
    consentResponse,
    policyVersion,
  });

  const consentPayload = createConsentPayloadTyped({
    consent: versionedAcknowledgementPayload,
    consentType,
    patientId,
    policyMetadata,
  });

  return consentPayload;
}
